<div class="result-bullet-container" #bullet>
  <ng-container *ngIf="model">
    <result-bullet-part
      *ngFor="let bullet of model.parts.slice(0, bulletPartLimit)"
      [model]="bullet"
      [fallback]="fallback"
      [highlights]="highlights"
      (invoke)="onInvoke($event)"
      [ngClass]="{ truncate: truncate }"
      #bulletPart
    >
    </result-bullet-part>
    <result-bullet-part *ngIf="bulletPartLimit < model.parts.length" [model]="{ text: '+' + (model.parts.length - bulletPartLimit) }">
    </result-bullet-part>
    <span class="bullet-divider" [class.showDivider]="showDivider"></span>
  </ng-container>
</div>
